/**
 * An ObjectGroupObjects object.
 *
 * @property {Id} objectGroupObjectId   - ID of the assignment of a wfObject to a wfObject group
 * @property {Id} objectGroupId         - ID of the wfObject group
 * @property {Id} objectId              - ID of the wfObject
 */
export class ObjectGroupObjects {}
